import { ofType } from 'redux-observable';
import { ajax } from "rxjs/ajax";
import { of } from 'rxjs';

import {
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';

import {
  FETCH_MOBILE_APPS_LIST,
  FETCH_MOBILE_APPS_LIST_ERROR,
  SET_MOBILE_APPS_LIST,
} from '../constants';


const mobileAppsList = (action$, state$) => action$.pipe(
  ofType(FETCH_MOBILE_APPS_LIST),
  switchMap(() => ajax({
      url: `${state$.value.auth.server}/apps/${
        state$.value.insightsCriteria.insightType === 'organisation' &&
        state$.value.insightsCriteria.organisation.value
        ? `${
          state$.value.insightsCriteria.organisation.value
        }`
        : ''
      }`,
      headers: {
        Authorization: state$.value.auth.token,
      },
      responseType: 'json',
      crossDomain: true,
    }).pipe(
      map(response => {

        return ({
          type: SET_MOBILE_APPS_LIST,
          data: response.response,
        })
      }),
      catchError(error => of({
        type: FETCH_MOBILE_APPS_LIST_ERROR,
        error,
      }))
    ))
);

export default mobileAppsList;
